import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import httpClient from "../../custom-hooks/httpClient";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";

export const DownloadRedirect = () => {
  // const history = useHistory();
  const userAgent = window.navigator.userAgent.toLowerCase();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [referrerName, setReferrerName] = useState("")
  const params = useParams();
  const { referral_code } = params;

  useEffect(() => {
    httpClient
      .get(`/referral/${referral_code}`)
      .then(({ status, data }) => {
        setIsLoading(false);
        setReferrerName(data.referrer);
      })
      .catch((err) => {
        setIsLoading(false);
        // console.log(err.response.data);
        toast.info(err.response.data.message || "An error occurred");
      });
  }, [referral_code]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Set phone number in local storage

    // Get OTP
    httpClient
      .post(`/referral`, {
        referral_code,
        phone_number: `234${phoneNumber.substring(1)}`,
      })
      .then(({ status }) => {
        setIsLoading(false);
        console.log(userAgent);
        if (userAgent.includes("android")) {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.chamsmobile.android";
        } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
          window.location.href =
            "https://apps.apple.com/ng/app/kegow-wallet/id1607236016";
        }
      })
      .catch((err) => {
        setIsLoading(false);
        // console.log(err.response.data);
        toast.info(err.response.data.message || "An error occurred");
      });
  };
  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  return (
    <>
      <section
        className="section-border border-primary"
        style={{ backgroundColor: "#ECF3EE" }}
      >
        <div className="d-flex flex-column flex-lg-row min-vh-100 px-lg-10">
          <div className="d-lg-none d-flex flex-column py-5 justify-content-center gap-y-3 left-side">
            {/* <h1 className="fw-bold text-center text-primary mb-4">
              Welcome to
            </h1> */}
            <a
              className="navbar-brand text-center justify-items-center"
              href="/"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/kegow-315917.appspot.com/o/kegow-brand-asset%2FBrand.png?alt=media&token=e4c8c323-f66b-4f21-9ccd-bed750cf1ace"
                className="navbar-brand-img"
                alt="Kegow logo"
              />
            </a>
          </div>
          <div
            className="col-12 col-lg-6 d-flex align-items-center justify-content-center p-0 left-side vh-lg-100 sticky-top sticky"
            style={{ position: "sticky", top: "0" }}
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/kegow-315917.appspot.com/o/kegow-brand-asset%2FBAnner%20(3).png?alt=media&token=8b5d091c-c5a8-4d7f-912e-856b6edeeab5"
              className="img-fluid d-lg-none"
              alt="referral-banner-small"
              style={{ maxHeight: "400px" }}
            />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/kegow-315917.appspot.com/o/kegow-brand-asset%2FBAnner%20(4).png?alt=media&token=d93f640c-db59-456f-a440-fae8deea0e4c"
              className="img-fluid d-none d-lg-block object-fit-cover"
              alt="referral-banner-large"
            />
          </div>
          <div className="col-12 col-lg-6 d-flex flex-column py-lg-10 pb-lg-0 py-0 mb-6 right-side">
            <div className="d-lg-flex d-none d-flex flex-column mb-6 justify-content-center gap-y-3">
              <a
                className="navbar-brand text-center justify-items-center"
                href="/"
              >
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/kegow-315917.appspot.com/o/kegow-brand-asset%2FBrand.png?alt=media&token=e4c8c323-f66b-4f21-9ccd-bed750cf1ace"
                  className="navbar-brand-img"
                  alt="Kegow logo"
                />
              </a>
            </div>
            <small
              className="mx-lg-10 p-2 text-center text-white"
              style={{ backgroundColor: "#1D322D" }}
            >
              {referrerName} invited you to join the fun
            </small>
            <form className="mb-0 px-lg-10 py-lg-6 p-6" onSubmit={handleSubmit}>
              <label className="form-label" htmlFor="number">
                Phone number
              </label>
              <div className="input-group mb-6">
                <input
                  type="tel"
                  className="form-control"
                  placeholder="08012345678"
                  onChange={handleChange}
                  pattern="0[0-9]{10}"
                  value={phoneNumber}
                  title="Numbers only, like 08023456789"
                  maxLength="11"
                  id="number"
                  required
                />
              </div>

              {isLoading ? (
                <button className="btn w-100 btn-primary">
                  <Loader type="Oval" color="#fff" width={20} height={20} />
                </button>
              ) : (
                <button className="btn w-100 btn-primary" type="submit">
                  Download & Enjoy
                </button>
              )}
            </form>

            <div className="col-12 px-lg-10 px-6 border-rounded border-primary">
              <div className="bg-white rounded">
                <div className="py-2 container-fluid d-block text-center border-bottom border-primary">
                  <h3 className="text-center mb-0 fw-semibold ">
                    Benefits of using Kegow
                  </h3>
                </div>
                <div className="py-2 container-fluid d-flex">   
                </div>
                <div className="py-2 container-fluid d-flex">
                  <div>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="36"
                        height="36"
                        rx="18"
                        fill="#1C743A"
                        fillOpacity="0.08"
                      />
                      <path
                        d="M18.75 11.25V16.5H23.25L17.25 24.75V19.5H12.75L18.75 11.25Z"
                        stroke="#1D1D1D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M18.75 11.25L12.75 19.5"
                        stroke="#1C743A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="ms-5">
                    <h5 className="fs-6 m-0 fw-semibold ">
                      Fast & Smooth Bill Payment
                    </h5>
                    <small className="text-gray-700 fs-6 mb-6">
                      Pay bills with lightning speed.
                    </small>
                  </div>
                </div>
                <div className="py-2 container-fluid d-flex">
                  <div>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="36"
                        height="36"
                        rx="18"
                        fill="#1C743A"
                        fillOpacity="0.08"
                      />
                      <path
                        d="M24.75 15.2102V17.3875C24.75 21.6064 20.9529 24.1376 19.0545 25.1395C18.5992 25.3798 18.3716 25.5 18 25.5C17.6284 25.5 17.4008 25.3798 16.9455 25.1395C15.0471 24.1376 11.25 21.6064 11.25 17.3875V15.2102"
                        stroke="#1D1D1D"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M24.75 15.2102C24.75 13.9802 24.75 13.3652 24.4469 12.964C24.1438 12.5627 23.4586 12.3679 22.088 11.9783C21.1517 11.7122 20.3262 11.3915 19.6667 11.0987C18.7676 10.6996 18.318 10.5 18 10.5C17.682 10.5 17.2324 10.6996 16.3333 11.0987C15.6738 11.3915 14.8484 11.7121 13.912 11.9783C12.5414 12.3679 11.8562 12.5627 11.5531 12.964C11.25 13.3652 11.25 13.9802 11.25 15.2102"
                        stroke="#1C743A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="ms-5">
                    <h5 className="fs-6 m-0 fw-semibold ">
                      Security at its Peak
                    </h5>
                    <small className="text-gray-700 fs-6 mt-1">
                      Secure your transactions and more.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 py-lg-6 text-center fs-6 py-6 ">
              <Link
                to="/terms-and-conditions"
                className="text-decoration-none"
              >
                Terms and Conditions
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
